import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SearchAmenities from '../components/SearchAmenities.vue'
import Property from '../components/Property'

let Search
if (process.env.VUE_APP_CLIENT === 'petruth') {
  Search = require('../components/PetruthGroup.vue').default
} else {
  Search = require('../components/SearchWidget.vue').default
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: process.env.VUE_APP_CLIENT === 'petruth' ? Search : Home
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '/search2',
    name: 'searchAmenities',
    component: SearchAmenities
  },
  {
    path: '/property',
    name: 'property',
    component: Property
  }
]

// Petruth site links to /#/petruth-group — keep that route working
if (process.env.VUE_APP_CLIENT === 'petruth') {
  routes.push({
    path: '/petruth-group',
    name: 'petruthgroup',
    component: Search
  })
}

export default new VueRouter({
  // Petruth uses hash routes (#/petruth-group); Queenwood uses history
  mode: process.env.VUE_APP_CLIENT === 'petruth' ? 'hash' : 'history',
  routes
})
